export const filtersQuery = `
query Filters($criteria:ConfigurationCriteria){
  filters(criteria: $criteria) {
    customerGroups {id title nrOfProductConfigurations}
    products {
      id
      title
      nrOfProductConfigurations      
    }
    regions {
      id
      title
      nrOfProductConfigurations
    }
    modalities {
      id
      title
      nrOfProductConfigurations
    }
    productCollections {
      id
      title
      nrOfProductConfigurations
    }
    terms {
      id
      title
      nrOfProductConfigurations
    }
    classes {
      id
      title
      nrOfProductConfigurations
    }
    stops {
      id
      title
      nrOfProductConfigurationsAsFromStop
      nrOfProductConfigurationsAsToStop
    }
    zones {
      id
      title
      nrOfProductConfigurations
    }
    starValues {
      id
      title
      nrOfProductConfigurations
    }
    salesChannels {
      id
      title
      nrOfProductConfigurations
    }
  }
}
`



// WEBPACK FOOTER //
// ./src/products-api/queries/filters.js